import React from 'react';
import { reduxForm, reset } from 'redux-form';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import FormData from './form-data';

//form input validations
const validate = (values, props) => {
/* in the comments there are validation messages - not used at the moment  */

/*   const errorValue = Object.entries(props.formData).map(([key,value])=>{
    console.log(value.name)
  }); */

  const errors = {}

  if (!values.name) {
    errors.name = ' '//props.translate('Contact_Form_Name_ErrorMessage')
  }
  if (!values.email) {
    errors.email = ' '//props.translate('Contact_Form_Email_ErrorMessage')
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = ' '//props.translate('Contact_Form_Email_ErrorMessage_InvalidEmail')
  }
  if (!values.phone) {
    errors.phone = ' '//props.translate('Contact_Form_Subject_ErrorMessage')
  }  
  if (!values.message) {
    errors.message = ' '//props.translate('Contact_Form_Body_ErrorMessage')
  }    
  return errors
}
 
//clear form at onSubmitSuccess
const clearForm = (result, dispatch) => {
  dispatch(reset('simple'))
}

const SimpleForm = (props)=> {
  const { handleSubmit, pristine, submitting } = props
  return (
    <form onSubmit={handleSubmit} className="cf" id="contactForm">
      <FormData inputData={props.formData}/>
      <div className="form-group">
        
        {/*  submit button */}
        <button className="btn btn-primary btn-lg" type="submit" disabled={pristine || submitting}>
          {/* {props.translate(props.submitButtonName)} */}
          {props.translate(props.submitButtonName).props.children}

        </button>
        

      </div>
      <div id="success-send"> {props.translate(props.formDataSucessMessage)} </div>
    </form>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(reduxForm({ form: 'simple', validate, onSubmitSuccess: clearForm })(SimpleForm));





// WEBPACK FOOTER //
// ./src/components/form/form.jsx